interface Rule {
  required?: boolean
  mailaddress?: boolean
  maxLength?: number
  minLength?: number
  password?: boolean
}

export class Validation {

  private readonly rules: { [key: string]: Rule } = {}
  private errors: { [key: string]: string[] } = {}

  constructor(rules: { [key: string]: Rule }) {
    this.rules = rules
  }

  validate(param: { [key: string]: any }) {

    for (let prop of Object.keys(this.rules)) {
      const rule: Rule = this.rules[prop]
      const value = param.hasOwnProperty(prop) ? param[prop] : undefined

      if (rule.required) {
        if (value === undefined || value === null || value === "") {
          this.addError(prop, `Required.`)
          continue
        }
      }

      if (rule.mailaddress) {
        if (!value.match(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i)) {
          this.addError(prop, "invalid E-Mail format.")
        }
      }

      if (rule.maxLength) {
        if (value.length > rule.maxLength) {
          this.addError(prop, `The maximum character length that you can add is ${rule.maxLength} characters.`)
        }
      }

      if (rule.minLength) {
        if (value.length < rule.minLength) {
          this.addError(prop, `The minimum character length that you can add is ${rule.minLength} characters.`)
        }
      }

      // if (rule.password) {
      //   if (!value.match(/[\p{L}\p{M}\p{S}\p{N}\p{P}]+/)) {
      //     this.addError(prop, `Invalid password format. Contain at least one number, uppercase, lowercase and symbol character`)
      //   }
      // }

    }

    return Object.keys(this.errors).length === 0
  }

  getErrors() {
    return this.errors
  }

  private addError(prop: string, message: string) {

    if (!this.errors.hasOwnProperty(prop)) {
      this.errors[prop] = []
    }

    this.errors[prop].push(message)
  }
}